import React, { Fragment } from "react";

const fontStyles = { fontSize: '14px', fontFamily: 'monospace' };

const detalleArticulo = props => {

    const { articulos } = props;

    const tablaHtml = articulos && articulos.length > 0 ?
        <table style={{ ...fontStyles, width: '100%' }}>
            <thead>
                <tr>
                    <th style={{ textAlign: "left" }}>Artículo</th>
                    <th style={{ textAlign: "right" }}>Cantidad</th>
                </tr>
            </thead>
            <tbody>
                {
                    articulos.map(articulo =>
                        <Fragment key={articulo.Articulo_Id}>
                            <tr>
                                <td>{`${articulo.Articulo_Codigo_Principal ? articulo.Articulo_Codigo_Principal : articulo.Articulo_Id} - ${articulo.Articulo_Nombre}`}</td>
                                <td style={{ textAlign: "right" }}>{articulo.Detalle_Facturar}</td>
                            </tr>
                            {
                                articulo.Articulo_Posicion ?
                                    <tr>
                                        <td colSpan="2">{`Ubicación: ${articulo.Articulo_Posicion}`}</td>
                                    </tr>
                                    : null
                            }
                        </Fragment>
                    )
                }
            </tbody>
        </table>
        : null;

    return (tablaHtml);
}

export default detalleArticulo;